import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { merchantList } from '../../models/merchant.models';

@Injectable({
  providedIn: 'root'
})
export class MerchantService {

  constructor(private http: HttpClient) { }

  getMerchants(skip: number, limit: number): Promise<any>{
    let getMerchantsEndPoint = "https://api.ewns.in/api/Admin/merchants?skip="+ skip + "&limit=" + limit;
    return this.http.get<merchantList>(getMerchantsEndPoint).toPromise();
  }
}
